/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './permission_flags';
import './permission_group_flags';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "empermissions": {
        "nested": {
          "displaypermissions": {
            "nested": {
              "AccessPointFlag": {
                "values": {
                  "ACCESS_POINT_DO_NOT_USE": 0,
                  "SHARED_POS": 1,
                  "DASHBOARD": 2,
                  "MOBILE_POS": 3
                }
              },
              "RoleType": {
                "values": {
                  "ROLE_TYPE_DO_NOT_USE": 0,
                  "CUSTOM": 1,
                  "ACCOUNT_OWNER": 2,
                  "TEAM_PERMISSIONS": 3,
                  "EXTRA": 4
                }
              },
              "PermissionSet": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "fullAccess": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "roleType": {
                    "type": ".squareup.empermissions.displaypermissions.RoleType",
                    "id": 4,
                    "rule": "optional"
                  },
                  "disabledReasons": {
                    "type": ".squareup.empermissions.displaypermissions.PermissionSet.DisabledReason",
                    "id": 10,
                    "rule": "repeated"
                  },
                  "accessPointFlagBitset": {
                    "type": "bytes",
                    "id": 5,
                    "rule": "optional"
                  },
                  "accessPointFlags": {
                    "type": ".squareup.empermissions.displaypermissions.AccessPointFlag",
                    "id": 9,
                    "rule": "repeated"
                  },
                  "enabledPermissions": {
                    "type": ".squareup.empermissions.displaypermissions.EnabledPermission",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "createdAt": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "DisabledReason": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "MISSING_SHIFTS_SUBSCRIPTION": 1,
                      "MISSING_COMMS_SUBSCRIPTION": 2,
                      "MISSING_TEAM_PLUS_SUBSCRIPTION": 3
                    }
                  }
                }
              },
              "Permission": {
                "fields": {
                  "permissionFlag": {
                    "type": ".squareup.empermissions.displaypermissions.PermissionFlag",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "supportedAccessPointFlagsBitset": {
                    "type": "bytes",
                    "id": 3,
                    "rule": "optional"
                  },
                  "hasFilters": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "type": {
                    "type": ".squareup.empermissions.displaypermissions.Permission.Type",
                    "id": 5,
                    "rule": "optional"
                  },
                  "enabledByDefaultIfGroupEnabled": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "children": {
                    "type": ".squareup.empermissions.displaypermissions.Permission",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "description": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "TYPE_DO_NOT_USE": 0,
                      "REGULAR": 1,
                      "INHERIT_PARENT": 2,
                      "FULL_ACCESS_ONLY": 3
                    }
                  }
                }
              },
              "PermissionGroup": {
                "fields": {
                  "permissionGroupFlag": {
                    "type": ".squareup.empermissions.displaypermissions.PermissionGroupFlag",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "helpText": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "smallSvgIconUrl": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "mediumSvgIconUrl": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "subgroups": {
                    "type": ".squareup.empermissions.displaypermissions.PermissionGroup.SubgroupList",
                    "id": 5
                  },
                  "permissionAlias": {
                    "type": ".squareup.empermissions.displaypermissions.PermissionGroup.PermissionAlias",
                    "id": 6
                  }
                },
                "nested": {
                  "SubgroupList": {
                    "fields": {
                      "list": {
                        "type": ".squareup.empermissions.displaypermissions.PermissionGroup.Subgroup",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "Subgroup": {
                    "fields": {
                      "header": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "permissions": {
                        "type": ".squareup.empermissions.displaypermissions.Permission",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  },
                  "PermissionAlias": {
                    "fields": {
                      "permission": {
                        "type": ".squareup.empermissions.displaypermissions.Permission",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "type": {
                    "oneof": ["subgroups", "permissionAlias"]
                  }
                }
              },
              "EnabledPermission": {
                "fields": {
                  "permissionFlag": {
                    "type": ".squareup.empermissions.displaypermissions.PermissionFlag",
                    "id": 1,
                    "rule": "optional"
                  },
                  "filterTokens": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "FilterEntities": {
                "fields": {
                  "permissionFlag": {
                    "type": ".squareup.empermissions.displaypermissions.PermissionFlag",
                    "id": 1,
                    "rule": "optional"
                  },
                  "entityName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "name": {
                    "type": ".squareup.empermissions.displaypermissions.FilterEntities.Name",
                    "id": 4,
                    "rule": "optional"
                  },
                  "entities": {
                    "type": ".squareup.empermissions.displaypermissions.FilterEntities.Entity",
                    "id": 3,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Entity": {
                    "fields": {
                      "filterToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "title": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "isReadOnly": {
                        "type": "bool",
                        "id": 3,
                        "rule": "optional"
                      },
                      "isFullAccessOnly": {
                        "type": "bool",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  },
                  "Name": {
                    "fields": {
                      "title": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "one": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "other": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "all": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "description": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "action": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      },
                      "selectHint": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "PermissionSetTemplate": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "subtext": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "fullAccess": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "permissionFlags": {
                    "type": ".squareup.empermissions.displaypermissions.PermissionFlag",
                    "id": 6,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.empermissions?.nested?.displaypermissions?.nested?.AccessPointFlag && !$root.nested?.squareup?.nested?.empermissions?.nested?.displaypermissions?.nested?.RoleType && !$root.nested?.squareup?.nested?.empermissions?.nested?.displaypermissions?.nested?.PermissionSet && !$root.nested?.squareup?.nested?.empermissions?.nested?.displaypermissions?.nested?.PermissionSet?.nested?.DisabledReason && !$root.nested?.squareup?.nested?.empermissions?.nested?.displaypermissions?.nested?.Permission && !$root.nested?.squareup?.nested?.empermissions?.nested?.displaypermissions?.nested?.Permission?.nested?.Type && !$root.nested?.squareup?.nested?.empermissions?.nested?.displaypermissions?.nested?.PermissionGroup && !$root.nested?.squareup?.nested?.empermissions?.nested?.displaypermissions?.nested?.PermissionGroup?.nested?.SubgroupList && !$root.nested?.squareup?.nested?.empermissions?.nested?.displaypermissions?.nested?.PermissionGroup?.nested?.Subgroup && !$root.nested?.squareup?.nested?.empermissions?.nested?.displaypermissions?.nested?.PermissionGroup?.nested?.PermissionAlias && !$root.nested?.squareup?.nested?.empermissions?.nested?.displaypermissions?.nested?.EnabledPermission && !$root.nested?.squareup?.nested?.empermissions?.nested?.displaypermissions?.nested?.FilterEntities && !$root.nested?.squareup?.nested?.empermissions?.nested?.displaypermissions?.nested?.FilterEntities?.nested?.Entity && !$root.nested?.squareup?.nested?.empermissions?.nested?.displaypermissions?.nested?.FilterEntities?.nested?.Name && !$root.nested?.squareup?.nested?.empermissions?.nested?.displaypermissions?.nested?.PermissionSetTemplate) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE AccessPointFlag @ squareup/empermissions/displaypermissions/permissions.proto at 11:1
 */
export const AccessPointFlag = $root.lookupEnum('squareup.empermissions.displaypermissions.AccessPointFlag').values;
/**
 * SOURCE RoleType @ squareup/empermissions/displaypermissions/permissions.proto at 24:1
 */
export const RoleType = $root.lookupEnum('squareup.empermissions.displaypermissions.RoleType').values;
/**
 * SOURCE PermissionSet @ squareup/empermissions/displaypermissions/permissions.proto at 36:1
 */
export const PermissionSet = $root.lookupType('squareup.empermissions.displaypermissions.PermissionSet');
fixType(PermissionSet, {
  name: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(PermissionSet);
/**
 * SOURCE DisabledReason @ squareup/empermissions/displaypermissions/permissions.proto at 72:3
 */
PermissionSet.DisabledReason = $root.lookupEnum('squareup.empermissions.displaypermissions.PermissionSet.DisabledReason').values;
/**
 * Additional metadata and structure about a DisplayPermission
 *
 * SOURCE Permission @ squareup/empermissions/displaypermissions/permissions.proto at 83:1
 */
export const Permission = $root.lookupType('squareup.empermissions.displaypermissions.Permission');
fixType(Permission, {
  name: {
    notEmpty: true
  },
  type: {
    required: true
  }
});
Builder.createAndAttachToType(Permission);
/**
 * SOURCE Type @ squareup/empermissions/displaypermissions/permissions.proto at 109:3
 */
Permission.Type = $root.lookupEnum('squareup.empermissions.displaypermissions.Permission.Type').values;
/**
 * Additional metadata and structure about a DisplayPermissionGroup
 *
 * SOURCE PermissionGroup @ squareup/empermissions/displaypermissions/permissions.proto at 127:1
 */
export const PermissionGroup = $root.lookupType('squareup.empermissions.displaypermissions.PermissionGroup');
fixType(PermissionGroup, {
  name: {
    notEmpty: true
  },
  helpText: {
    notEmpty: true
  },
  smallSvgIconUrl: {
    notEmpty: true
  },
  mediumSvgIconUrl: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(PermissionGroup);
/**
 * Wrapper for `repeated` since `oneof { repeated ... }` doesn't work.
 *
 * SOURCE SubgroupList @ squareup/empermissions/displaypermissions/permissions.proto at 150:3
 */
PermissionGroup.SubgroupList = $root.lookupType('squareup.empermissions.displaypermissions.PermissionGroup.SubgroupList');
fixType(PermissionGroup.SubgroupList);
Builder.createAndAttachToType(PermissionGroup.SubgroupList);
/**
 * SOURCE Subgroup @ squareup/empermissions/displaypermissions/permissions.proto at 154:3
 */
PermissionGroup.Subgroup = $root.lookupType('squareup.empermissions.displaypermissions.PermissionGroup.Subgroup');
fixType(PermissionGroup.Subgroup, {
  header: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(PermissionGroup.Subgroup);
/**
 * SOURCE PermissionAlias @ squareup/empermissions/displaypermissions/permissions.proto at 160:3
 */
PermissionGroup.PermissionAlias = $root.lookupType('squareup.empermissions.displaypermissions.PermissionGroup.PermissionAlias');
fixType(PermissionGroup.PermissionAlias, {
  permission: {
    required: true
  }
});
Builder.createAndAttachToType(PermissionGroup.PermissionAlias);
/**
 * A display permission that is enabled for a role
 *
 * SOURCE EnabledPermission @ squareup/empermissions/displaypermissions/permissions.proto at 170:1
 */
export const EnabledPermission = $root.lookupType('squareup.empermissions.displaypermissions.EnabledPermission');
fixType(EnabledPermission, {
  permissionFlag: {
    required: true
  }
});
Builder.createAndAttachToType(EnabledPermission);
/**
 * A list of entities that can have a display permission applied to it. For example, the MANAGE_EMPLOYEES display
 * permission may have an associated FilterEntities like:
 *
 *    { permission: "MANAGE_EMPLOYEES",
 *      entities: [
 *        { filter_token: "role1-token", title: "Administrator"},
 *        { filter_token: "role2-token", title: "Cashier"},
 *        ...
 *      ]}
 *
 * Using the above example, the `EnabledDisplayPermissionDefinition.filter_tokens` is where you would define something
 * like "This permission only applies to the Cashier and Bartender roles"
 *
 * SOURCE FilterEntities @ squareup/empermissions/displaypermissions/permissions.proto at 191:1
 */
export const FilterEntities = $root.lookupType('squareup.empermissions.displaypermissions.FilterEntities');
fixType(FilterEntities, {
  permissionFlag: {
    required: true
  },
  entityName: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(FilterEntities);
/**
 * next id = 5
 *
 * SOURCE Entity @ squareup/empermissions/displaypermissions/permissions.proto at 203:3
 */
FilterEntities.Entity = $root.lookupType('squareup.empermissions.displaypermissions.FilterEntities.Entity');
fixType(FilterEntities.Entity, {
  filterToken: {
    notEmpty: true
  },
  title: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(FilterEntities.Entity);
/**
 * SOURCE Name @ squareup/empermissions/displaypermissions/permissions.proto at 213:3
 */
FilterEntities.Name = $root.lookupType('squareup.empermissions.displaypermissions.FilterEntities.Name');
fixType(FilterEntities.Name, {
  title: {
    notEmpty: true
  },
  one: {
    notEmpty: true
  },
  other: {
    notEmpty: true
  },
  all: {
    notEmpty: true
  },
  description: {
    notEmpty: true
  },
  action: {
    notEmpty: true
  },
  selectHint: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(FilterEntities.Name);
/**
 * SOURCE PermissionSetTemplate @ squareup/empermissions/displaypermissions/permissions.proto at 231:1
 */
export const PermissionSetTemplate = $root.lookupType('squareup.empermissions.displaypermissions.PermissionSetTemplate');
fixType(PermissionSetTemplate, {
  id: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(PermissionSetTemplate);